module.exports = {
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Login',
            component: require('@/components/Login')
        },
        {
            path: '/templates',
            name: 'templates',
            component: require('@/components/TemplatePicker'),
            children: [
                {
                    path: ':type',
                    name: 'template-type',
                    component: require('@/components/TemplatePicker'),
                    children: [
                        {
                            path: ':uuid',
                            name: 'template-category',
                            component: require('@/components/TemplatePicker'),
                            children: [
                                {
                                    path: 'subcategory/:subcat',
                                    name: 'template-subcat',
                                    component: require('@/components/TemplatePicker'),
                                    children: [
                                        {
                                            path: ':page',
                                            name: 'template-subcat-page',
                                            component: require('@/components/TemplatePicker')
                                        }
                                    ]
                                },
                                {
                                    path: ':page',
                                    name: 'template-page',
                                    component: require('@/components/TemplatePicker')
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            path: '/designer/:uuid',
            name: 'designer',
            component: require('@/components/TemplateDesigner')
        },
        {
            path: '/options',
            name: 'template-options',
            component: require('@/components/TemplateOptions')
        }
    ]
}
// meta: {auth: ['customer']},



// WEBPACK FOOTER //
// ./src/router/index.js